/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Errordeleting1Inputs */

const id_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kesalahan menghapus ulasan`)
};

const ms_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ralat memadam ulasan`)
};

const da_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fejl ved sletning af anmeldelse`)
};

const de_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Löschen der Bewertung`)
};

const en_us2_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting review`)
};

const es_es2_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar la reseña`)
};

const es_mx2_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al eliminar la reseña`)
};

const fil_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error sa pagtanggal ng review`)
};

const fr_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la suppression de l'avis`)
};

const it_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore nell'eliminazione della recensione`)
};

const hu_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiba az értékelés törlésekor`)
};

const nl_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij verwijderen review`)
};

const no_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feil ved sletting av omtale`)
};

const pl_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Błąd usuwania recenzji`)
};

const pt_br2_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting review`)
};

const pt_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao eliminar avaliação`)
};

const ro_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eroare la ștergerea recenziei`)
};

const fi_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Virhe arvostelun poistossa`)
};

const sv_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fel vid borttagning av recension`)
};

const vi_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lỗi khi xóa đánh giá`)
};

const tr_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yorum silinirken hata oluştu`)
};

const cs_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chyba při mazání recenze`)
};

const bg_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Грешка при изтриване на ревю`)
};

const ru_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при удалении обзора`)
};

const uk_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Помилка видалення відгуку`)
};

const ar_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خطأ في حذف المراجعة`)
};

const hi_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हटाने में त्रुटि`)
};

const th_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อผิดพลาดในการลบรีวิว`)
};

const ja_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レビューの削除エラー`)
};

const zh_cn2_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting review`)
};

const zh_hant1_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting review`)
};

const ko_forms_review_errordeleting1 = /** @type {(inputs: Forms_Review_Errordeleting1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error deleting review`)
};

/**
* | output |
* | --- |
* | "Error deleting review" |
*
* @param {Forms_Review_Errordeleting1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_errordeleting1 = /** @type {((inputs?: Forms_Review_Errordeleting1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Errordeleting1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_errordeleting1(inputs)
	if (locale === "ms") return ms_forms_review_errordeleting1(inputs)
	if (locale === "da") return da_forms_review_errordeleting1(inputs)
	if (locale === "de") return de_forms_review_errordeleting1(inputs)
	if (locale === "en-US") return en_us2_forms_review_errordeleting1(inputs)
	if (locale === "es-ES") return es_es2_forms_review_errordeleting1(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_errordeleting1(inputs)
	if (locale === "fil") return fil_forms_review_errordeleting1(inputs)
	if (locale === "fr") return fr_forms_review_errordeleting1(inputs)
	if (locale === "it") return it_forms_review_errordeleting1(inputs)
	if (locale === "hu") return hu_forms_review_errordeleting1(inputs)
	if (locale === "nl") return nl_forms_review_errordeleting1(inputs)
	if (locale === "no") return no_forms_review_errordeleting1(inputs)
	if (locale === "pl") return pl_forms_review_errordeleting1(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_errordeleting1(inputs)
	if (locale === "pt") return pt_forms_review_errordeleting1(inputs)
	if (locale === "ro") return ro_forms_review_errordeleting1(inputs)
	if (locale === "fi") return fi_forms_review_errordeleting1(inputs)
	if (locale === "sv") return sv_forms_review_errordeleting1(inputs)
	if (locale === "vi") return vi_forms_review_errordeleting1(inputs)
	if (locale === "tr") return tr_forms_review_errordeleting1(inputs)
	if (locale === "cs") return cs_forms_review_errordeleting1(inputs)
	if (locale === "bg") return bg_forms_review_errordeleting1(inputs)
	if (locale === "ru") return ru_forms_review_errordeleting1(inputs)
	if (locale === "uk") return uk_forms_review_errordeleting1(inputs)
	if (locale === "ar") return ar_forms_review_errordeleting1(inputs)
	if (locale === "hi") return hi_forms_review_errordeleting1(inputs)
	if (locale === "th") return th_forms_review_errordeleting1(inputs)
	if (locale === "ja") return ja_forms_review_errordeleting1(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_errordeleting1(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_errordeleting1(inputs)
	return ko_forms_review_errordeleting1(inputs)
});
export { forms_review_errordeleting1 as "forms.review.errorDeleting" }